import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import CreateEntryFromTemplateModal, {
  CreateEntryFromTemplateModalProps,
} from 'notebook/entry-templates/CreateEntryFromTemplateModal/CreateEntryFromTemplateModal';
import LegacyCreateEntryFromTemplateModalClass from 'notebook/entry-templates/LegacyCreateEntryFromTemplateModal';
import ButtonWithDisabledReason from 'ui-library/buttons/ButtonWithDisabledReason';
import legacyRunModal from 'ui-library/legacyRunModal';

export type CreateEntryFromTemplateSubmission = Parameters<
  CreateEntryFromTemplateModalProps['onRequestSubmit']
>[0];

interface CreateEntryFromTemplateButtonBaseProps {
  buttonId: string;
  buttonText: string;
  disabledMessage: string | null;
  filterTemplateIds?: Array<string>;
  onRequestSubmit: (submission: CreateEntryFromTemplateSubmission) => void;
  showUnpublishedCollectibles?: boolean;
  templateId: string;
}

export default function CreateEntryFromTemplateButtonBase({
  buttonId,
  buttonText,
  disabledMessage,
  filterTemplateIds,
  onRequestSubmit,
  showUnpublishedCollectibles,
  templateId,
}: CreateEntryFromTemplateButtonBaseProps): JSX.Element {
  const showModal = (): void => {
    // TODO(BNCH-38468): Remove feature flag after rollout and discontinue legacy modal.
    if (!BenchlingConfig.ELN_ENABLE_SCHEMA_ON_ENTRY_CREATE_MODAL) {
      LegacyCreateEntryFromTemplateModalClass.open({
        filterTemplateIds,
        initialTemplateId: templateId,
        initialFolderId: FolderDefaults.get(FolderDefaultsKey.NOTEBOOK),
        onRequestSubmit,
        showUnpublishedCollectibles,
      });
    } else {
      legacyRunModal(CreateEntryFromTemplateModal, {
        filterTemplateIds,
        initialTemplateId: templateId,
        initialFolderId: FolderDefaults.get(FolderDefaultsKey.NOTEBOOK),
        onRequestClose: () => {},
        onRequestSubmit,
        isTemplateSelectorDisabled: false,
        showUnpublishedCollectibles,
      });
    }
  };

  return (
    <ButtonWithDisabledReason
      disabledTooltip={disabledMessage}
      fullWidth={true}
      id={buttonId}
      onClick={showModal}
      size="sm"
      variant="primary"
    >
      {buttonText}
    </ButtonWithDisabledReason>
  );
}
